import type { OrderStatus } from '@posilka/shared';
import { useTranslation } from 'react-i18next';

const TONE: Record<OrderStatus, string> = {
  OPEN: 'bg-sky/15 text-sky',
  ACCEPTED: 'bg-amber/15 text-amber',
  PICKED_UP: 'bg-violet/15 text-violet',
  DELIVERED: 'bg-lime/20 text-accent',
  CANCELLED: 'bg-muted/15 text-muted',
  EXPIRED: 'bg-muted/15 text-muted',
  DISPUTED: 'bg-danger/15 text-danger',
};

export function StatusBadge({ status }: { status: OrderStatus }) {
  const { t } = useTranslation();
  return (
    <span
      className={`inline-flex shrink-0 items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] leading-none font-bold whitespace-nowrap ${TONE[status]}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {t(`status.${status}`)}
    </span>
  );
}
